import React from 'react';
import { useTheme } from '../App';

function StatusBar({ subreddit, page, totalPosts, loading, selectedIndex }) {
  const { theme } = useTheme();
  
  const statusBarStyle = {
    borderTop: `1px solid ${theme.colors.border}`,
    padding: '5px 15px',
    fontSize: '12px',
    color: theme.colors.accentCyan,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.colors.background2,
    margin: '0 -20px -20px -20px',
    width: 'calc(100% + 40px)',
  };

  const getSubredditDisplay = () => {
    if (['hot', 'popular'].includes(subreddit)) {
      return subreddit.toUpperCase();
    }
    return `r/${subreddit}`;
  };

  const formatTime = () => {
    const now = new Date();
    return now.toLocaleTimeString('en-US', { 
      hour12: false, 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <div style={statusBarStyle}>
      <div style={{ display: 'flex', gap: '20px' }}>
        <span>{getSubredditDisplay()}</span>
        <span>Page {page}</span>
        <span>{totalPosts} posts</span>
        {selectedIndex >= 0 && <span style={{ color: theme.colors.accentGreen }}>Selected: {selectedIndex + 1}</span>}
      </div>
      <div style={{ display: 'flex', gap: '20px' }}>
        {loading && <span style={{ color: theme.colors.accentOrange }}>Loading...</span>}
        <span>{formatTime()}</span>
      </div>
    </div>
  );
}

export default StatusBar;